import {useEffect} from "react";

import {selectAppRoleLabel} from "../redux/envSlice";
import {useRevaSelector} from "../redux/revaHooks";
import {selectMostRelevantExternalOrderNumber} from "../redux/valueOrdersSelectors";

/**
 * React hook to update the app title, dependent on the currently loaded valuation.
 */
export function useDynamicAppTitle(): void {
    const roleLabel = useRevaSelector(selectAppRoleLabel);
    const externalOrderNumber = useRevaSelector(selectMostRelevantExternalOrderNumber);

    useEffect(() => {
        const computedTitle = externalOrderNumber ?? "VALUE REVA";
        const roleLabelSuffix = roleLabel ? ` (${roleLabel})` : "";
        document.title = computedTitle + roleLabelSuffix;
    }, [roleLabel, externalOrderNumber]);
}
